import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderModel } from './loader.model';

@Injectable()
export class LoaderService {

  loaderSubject = new Subject<LoaderModel>();
  loaderObserver = this.loaderSubject.asObservable();
  loaderModel: LoaderModel = new LoaderModel();
  constructor() { }

  start(loaderModel?: any) {
    if (loaderModel !== undefined) {
      this.loaderModel.isLoading = loaderModel.isLoading;
      this.loaderModel.message = loaderModel.message;
    } else {
      this.loaderModel.message = 'Please wait..';
      this.loaderModel.isLoading = true;
    }
    this.loaderSubject.next(this.loaderModel);
  }

  stop() {
    this.loaderModel.isLoading = false;
    this.loaderSubject.next(this.loaderModel);
  }

}
